import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

import { colors, radius } from '../../../styles/tokens';

interface ContainerProps {
  type?: 'info' | 'success' | 'error';
  hasDescription?: number;
}

const toastTypeVariations = {
  info: css`
    border-left: 4px solid ${colors.primary};
    color: ${colors.primary};
  `,
  success: css`
    border-left: 4px solid ${colors.success};
    color: ${colors.success};
  `,
  error: css`
    border-left: 4px solid ${colors.error};
    color: ${colors.error};
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 360px;

  position: relative;
  padding: 16px 30px 16px 16px;

  border-radius: ${radius.DEFAULT};
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);

  display: flex;

  & + div {
    margin-top: 8px;
  }

  background: ${colors.surfaceContainerHigh};
  color: ${colors.onSurface};

  ${props => toastTypeVariations[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    strong {
      color: ${colors.onSurface};
    }

    p {
      margin-top: 4px;
      font-size: 14px;
      color: ${colors.onSurfaceVariant};
      line-height: 20px;
    }
  }

  button {
    position: absolute;
    right: 16px;
    top: 19px;
    opacity: 0.6;
    border: 0;
    background: transparent;
    color: ${colors.onSurfaceVariant};
  }

  ${props =>
    !props.hasDescription &&
    css`
      align-items: center;
    `}

  @media (max-width: 1199px) {
    width: calc(60vw);
  }
`;
